<template>
    <div>
      <el-cascader
        :ref="`cascader-${cascaderId}`"
        class="w-100"
        size="small"
        v-model="selectedOptions"
        :options="optionsCInternal"
        :props="props"
        multiple
        filterable
        clearable
        collapse-tags
        show-all-levels
        placeholder="Selecione as opções"
        :filter-method="handleFilter"
        :popper-class="`cascade-custom-${cascaderId}`"
        @change="changeValue"
        v-bind="$attrs"
        @visible-change="onCascaderFocus"
      ></el-cascader>
    </div>
</template>
<script>

export default {
    name: 'centro-de-custo',
    props: ['value', 'url'],
    data() {
        return {
            cascaderId: null,
            isLoading: false,
            selectedOptions: [],
            props: { 
                multiple: true,
                checkStrictly: false,
                value: 'id'
            },
            optionsCInternal: [],
            hasInteracted: false,
            currentUrl: this.url,
        }
    },
    methods: {
        onCascaderFocus(visible) {
          if (visible && (!this.hasInteracted || this.urlChanged)) {
            this.hasInteracted = true;
            this.getCentroDeCusto();
          }
        },
        handleUrlChange(newUrl) {
          if (this.url !== newUrl) {
            this.currentUrl = newUrl;
            this.hasInteracted = false;
          }
        },
        async getCentroDeCusto() {
          this.isLoading = true;
          try {
            const remoteData = await this.axios.get(this.url);
            this.optionsCInternal = remoteData.data;
            this.$emit('options-loaded', this.optionsCInternal);
            this.$emit('input', []);
          } catch (error) {
            console.error('Erro ao carregar dados:', error);
          } finally {
            this.isLoading = false;
          }
        },
        handleFilter(option, query) {
          if (!query) return true; // Mostrar todos

          // Verifique se o rótulo do item ou qualquer rótulo pai contém a consulta
          const labels = [option.label, ...option.pathLabels];
          for (const label of labels) {
            if (label.toLowerCase().includes(query.toLowerCase())) {
              return true;
            }
          }

          return false;
        },
        changeValue(values) {
            let idsFinal = []

            if(values.length) {
                idsFinal = values.map(ids => ids[1])
            }

            this.$emit('input',idsFinal)
        },
        handleLoadingText() {
          this.$nextTick(() => {
            const dropdown = document.querySelector(`.cascade-custom-${this.cascaderId} .el-scrollbar__view .el-cascader-menu__empty-text`);
            if (dropdown) {
              if (this.isLoading) {
                dropdown.innerHTML = 'Carregando<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>';
              } else if (!this.optionsCInternal.length) {
                dropdown.textContent = 'Sem Dados';
              }
            }
          })
        },
    },
    watch: {
      isLoading(load) {
        this.handleLoadingText(load);
      },
      url(newUrl) {
        this.handleUrlChange(newUrl);
      },
    },
    computed: {
      urlChanged() {
        return this.url !== this.currentUrl;
      },
    },
    created() {
      this.cascaderId = this.generateSecureId();
    },
};
</script>
<style lang="scss">
.table-interna {
    padding-left: 46px;
    margin-top: -2px;
}
.dt-collapse {
    padding-left:20px;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 79px;
  height: 50px;
  margin-top: -21px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #c5c9d0;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
